import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/1ANV_logo_white.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-4480af80"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "login",
  class: "w-full h-full"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed anabLogo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_3 = { class: "fixed anabTeaserText" }
const _hoisted_4 = { class: "subline" }
const _hoisted_5 = { class: "headline" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { id: "loginSidebar" }
const _hoisted_8 = { style: {"text-align":"center"} }

import {onMounted} from 'vue';
import {useSystemStore} from "@/stores/system/SystemStore";
import {ErrorLocationType, SsoType} from "@/utilities/system/enums/Enums";
import Error from "@/components/system/Error.vue";
import LoadingSpinner from "@/components/system/LoadingSpinner.vue";
import OAuthService from "@/utilities/system/services/OAuthService";
import {SystemCompanySettings} from "@/models/entities/settings/SystemCompanySettings";
import {MiscService} from "@/utilities/system/services/entities/MiscService";
import {clientSpecs} from "@/AppConfig";
import {StartupConfig} from "@/models/system/StartupConfig";


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const systemStore = useSystemStore();
const miscService = new MiscService();

async function samlLogin() {
  const callbackUrl = encodeURIComponent(window.location.origin + "/saml/SamlCallback");
  const samlLoginUrl = systemStore.getAuthorityUrl() + "/saml/login?redirectUrl=" + callbackUrl + "?redirect_uri=" + callbackUrl;
  
  window.location.replace(samlLoginUrl);
}

const setStartupConfig = async ():Promise<boolean> => {
  try{
    const startupResp = await miscService.getStartupConfig(ErrorLocationType.login);
    console.log("startup:", startupResp);
    if (!startupResp) return false;

    systemStore.settings.defaultHiddenColumns = startupResp.defaultPreferences;
    systemStore.settings.systemCompanySettings = new SystemCompanySettings(startupResp.customerName, startupResp.idCode);
    systemStore.settings.startupConfig = new StartupConfig(startupResp.identityUrl, clientSpecs.clientId, clientSpecs.clientScopes, startupResp.ssoType);
    systemStore.settings.enabledFeatures = startupResp.enabledFeatures;

    return true;
  }
  catch (e) {
    console.log("CONFIG LOADING FAILED!", e);
    return false;
  }
}

onMounted (async ()=>{
  const success = await setStartupConfig();
  if(!success) return;

    if (systemStore.settings.startupConfig!.ssoType == SsoType.saml) {
      await samlLogin();
    }
    else if (systemStore.settings.startupConfig!.ssoType == SsoType.oauth) {
      const oAuthService = OAuthService.getDefaultInstance();
      await oAuthService.login();
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('login.subline')), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h1", null, [
          _createElementVNode("span", {
            innerHTML: _ctx.$t('login.headline')
          }, null, 8, _hoisted_6)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(LoadingSpinner),
        _createVNode(Error, {
          errorLoc: _unref(ErrorLocationType).login,
          class: "mt-4"
        }, null, 8, ["errorLoc"])
      ])
    ])
  ]))
}
}

})